import { render, staticRenderFns } from "./TQMForm.vue?vue&type=template&id=4a90e540&scoped=true"
import script from "./TQMForm.vue?vue&type=script&lang=js"
export * from "./TQMForm.vue?vue&type=script&lang=js"
import style0 from "./TQMForm.vue?vue&type=style&index=0&id=4a90e540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a90e540",
  null
  
)

export default component.exports